import * as yup from 'yup'

export const bulkApproveValidator = yup.object({
  reviewNotes: yup.string().test('not-blank', 'A reason is required', (value) => {
    return (value ?? '').trim().length > 0
  }),
  isAcknowledged: yup.boolean().test('ticked', 'Confirm to continue', (value) => {
    return value === true
  }),
})
